var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.invoiceStatus == "new"
    ? _c("span", { staticClass: "badge badge-info py-1 px-2" }, [
        _vm._v("Yeni"),
      ])
    : _vm.invoiceStatus == "paid"
    ? _c("span", { staticClass: "badge badge-success py-1 px-2" }, [
        _vm._v("Ödendi"),
      ])
    : _vm.invoiceStatus == "new_cancelled"
    ? _c("span", { staticClass: "badge badge-warning py-1 px-2" }, [
        _vm._v("İptal"),
      ])
    : _vm.invoiceStatus == "paid_cancelled"
    ? _c("span", { staticClass: "badge badge-warning py-1 px-2" }, [
        _vm._v("İptal"),
      ])
    : _c("span", { staticClass: "badge badge-warning py-1 px-2" }, [
        _vm._v("Yok"),
      ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }